"use client";

import { Box, styled, Typography } from "@mui/material";
import dayjs from "dayjs";

const Time = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: "10px",
}));

export default function DateTime({ date, hideTime = false }) {
  return (
    <Box sx={{ minWidth: "85px" }}>
      {dayjs(date).format("DD MMM YYYY")}
      {!hideTime && <Time>{dayjs(date).format("[at] hh:mma")}</Time>}
    </Box>
  );
}